import { useEffect } from 'react';

type JsonLdProps = {
  id: string;
  data: Record<string, unknown>;
};

/** Injects JSON-LD for rich results; removes on unmount. */
function JsonLd({ id, data }: JsonLdProps) {
  const jsonString = JSON.stringify(data);
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = jsonString;
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, [id, jsonString]);

  return null;
}

export default JsonLd;
